import React from 'react';
import { AlertTriangle, DollarSign, Wrench, Phone, Banknote } from 'lucide-react';
import { QuickStatsCard } from '@features/cx/shared/components/QuickStatsCard';
import { useSummaryDashboard } from '../../hooks';
import { useCurrency, useUserName } from '@shared/selectors/globalSelectors';


export const Dashboard: React.FC<{ selectedYear: number; selectedMonthLabel: number }> = ({ selectedYear, selectedMonthLabel }) => {
  const cachedProfile = useUserName();
  const currency = useCurrency();
  const { data: summaryDashboard } = useSummaryDashboard(cachedProfile,selectedYear, selectedMonthLabel);
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <QuickStatsCard 
        title="Payments Collected"
        count={currency + " " + summaryDashboard?.paymentAmount.current || 0}
        icon={<Banknote className="h-8 w-8 text-amber-500" />}
      />
      <QuickStatsCard 
        title="Services Raised"
        count={summaryDashboard?.serviceRequest.current || 0}
        icon={<Wrench className="h-8 w-8 text-blue-500" />}
      />
      <QuickStatsCard 
        title="Complaints Registered"
        count={summaryDashboard?.complaintsRegistered.current || 0}
        icon={<AlertTriangle className="h-8 w-8 text-red-500" />}
      />
      <QuickStatsCard 
        title="Total Calls"
        count={summaryDashboard?.totalCalls.current || 0}
        icon={<Phone className="h-8 w-8 text-green-500" />}
      />
    </div>
  );
};
